import { computed } from 'vue-demi';
import { useCurrentAccount, useCurrentUser } from '@teamwork/use';
import useRouter from '@/platform/composables/useRouter';
import useExperiment from '@/platform/composables/useExperiment';

const LD_EXPERIMENT_FLAG_KEY = 'projects-exp-32-help-modal-revision';

const useHelpMetrics = () => {
  const { trackPendoEventIfInExperiment } = useExperiment();
  const user = useCurrentUser();
  const account = useCurrentAccount();
  const router = useRouter();

  const getCommonPendoFields = () => {
    const userRole = computed(() => {
      if (user.value.siteOwner) {
        return 'site owner';
      }
      if (user.value.administrator) {
        return 'administrator';
      }
      if (user.value.isClientUser) {
        return 'client user';
      }
      if (user.value.isCollaborator) {
        return 'collaborator';
      }
      return undefined;
    });

    const planName = account.value.pricePlanData.name;
    const page = router.currentRoute.path;

    return {
      plan_name: planName.toLowerCase(),
      user_role: userRole.value,
      page,
    };
  };

  /**
   *  Submit a Pendo tracking event with already added
   *  common fields as detailed in Exp 32 - Measurement Plan
   *
   *  Ref: https://digitalcrew.teamwork.com/spaces/growth/page/37462-exp-32-measurement-plan
   * @param {string} eventName pendo event name
   * @param {Object} metadata pendo metadata object
   */
  const trackHelpEventInPendo = (eventName, metadata) => {
    trackPendoEventIfInExperiment(LD_EXPERIMENT_FLAG_KEY, eventName, {
      ...getCommonPendoFields(),
      ...metadata,
    });
  };

  return {
    trackHelpEventInPendo,
  };
};

export default useHelpMetrics;
